module.exports = __webpack_public_path__ + "img/huobi_dark.1c0b9636.svg";